import { useState } from 'react';

// Hộp thoại nhập tên (đổi tên danh mục, tạo/đổi tên album)
export default function RenameDialog({
  title,
  initial,
  onSubmit,
  onCancel,
  label = 'Tên mới',
  cancelLabel = 'Huỷ',
  saveLabel = 'Lưu',
  savingLabel = 'Đang lưu...',
}) {
  const [name, setName] = useState(initial);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      await onSubmit(name.trim());
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="dialog-backdrop" onClick={saving ? undefined : onCancel}>
      <form className="dialog quick-create" onClick={(e) => e.stopPropagation()} onSubmit={save} aria-label={title}>
        <h2>{title}</h2>
        <label>
          {label} <span className="required">*</span>
          <input required autoFocus maxLength={100} value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        {error && <p className="error">{error}</p>}
        <div className="dialog-actions">
          <button type="button" onClick={onCancel} disabled={saving}>
            {cancelLabel}
          </button>
          <button type="submit" className="primary" disabled={saving || !name.trim()}>
            {saving ? savingLabel : saveLabel}
          </button>
        </div>
      </form>
    </div>
  );
}
